import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import Loader from 'app/custom/loader/Loader'

const SchoolLecturerDashboard: React.FC = () => {
  const {t} = useTranslation()
  const [loader, setLoader] = useState(true)

  useEffect(() => {
    setLoader(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (loader) return <Loader />
  return <h1 className='text-center'>Lecturer Dashboard</h1>
}

export default SchoolLecturerDashboard
